var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13V15C6.4087 15 4.88258 15.6321 3.75736 16.7574C2.63214 17.8826 2 19.4087 2 21H0C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM8 10C10.21 10 12 8.21 12 6C12 3.79 10.21 2 8 2C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10ZM10.595 17.812C10.4682 17.2784 10.4682 16.7226 10.595 16.189L9.603 15.616L10.603 13.884L11.595 14.457C11.9932 14.0799 12.4745 13.8017 13 13.645V12.5H15V13.645C15.532 13.803 16.012 14.085 16.405 14.457L17.397 13.884L18.397 15.616L17.405 16.189C17.5316 16.7222 17.5316 17.2778 17.405 17.811L18.397 18.384L17.397 20.116L16.405 19.543C16.0068 19.9201 15.5255 20.1983 15 20.355V21.5H13V20.355C12.4745 20.1983 11.9932 19.9201 11.595 19.543L10.603 20.116L9.603 18.384L10.595 17.812ZM14 18.5C14.3978 18.5 14.7794 18.342 15.0607 18.0607C15.342 17.7794 15.5 17.3978 15.5 17C15.5 16.6022 15.342 16.2206 15.0607 15.9393C14.7794 15.658 14.3978 15.5 14 15.5C13.6022 15.5 13.2206 15.658 12.9393 15.9393C12.658 16.2206 12.5 16.6022 12.5 17C12.5 17.3978 12.658 17.7794 12.9393 18.0607C13.2206 18.342 13.6022 18.5 14 18.5Z",
    fill: "#D9BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6bacf345c5f39c9c8b3a0c55a2394a53.svg";
export { ForwardRef as ReactComponent };